import { __rest } from '../node_modules/tslib/tslib.es6.mjs.js';
import React__default from 'react';
import { isNextJS } from './utils.js';

const isNext = isNextJS();
// IMAGE ADAPTER
// dynamically render either nextjs 'image' or fallback to standard 'img' tag
const ImageAdapter = (_a) => {
    var _b;
    var { src: imgSrc } = _a, props = __rest(_a, ["src"]);
    const { isFuture = false, isNative = false, alt: alternate } = props, restProps = __rest(props, ["isFuture", "isNative", "alt"]);
    const src = (_b = imgSrc === null || imgSrc === void 0 ? void 0 : imgSrc.src) !== null && _b !== void 0 ? _b : imgSrc;
    if (!src)
        return React__default.createElement(React__default.Fragment, null);
    const alt = alternate || src.split('/').pop();
    if (!isNext || isNative)
        return React__default.createElement('img', Object.assign(Object.assign({ src, alt }, restProps), { loading: 'lazy', decoding: 'async', width: 'auto', height: '100%' }));
    try {
        const imageProps = Object.assign(Object.assign(Object.assign({ src,
            alt }, (!props.fill ? {
            layout: 'intrinsic', // default settings are just to guarantee it works, override this via props
            width: 600,
            height: 400
        } : {})), { unoptimized: true }), restProps);
        if (isFuture) {
            return React__default.createElement(require.resolve('next/future/image').default, imageProps);
        }
        else {
            return React__default.createElement(require.resolve('next/image').default, imageProps);
        }
    }
    catch (error) {
        return React__default.createElement('img', Object.assign({ src, alt }, restProps));
    }
};
ImageAdapter._isNextComponent = isNext;

export { ImageAdapter as default };
//# sourceMappingURL=Image.js.map
